import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../services/authentication.service'
import { HeaderTemplateData } from '../dialog-data.interface';
import { DatePipe, CurrencyPipe } from '@angular/common';

@Component({
    selector: 'dialog1-template',
    templateUrl: 'dialog1-template.html',
    styleUrls: ['dialog1-template.scss']
})
export class Dialog1Template implements OnInit {
    form: FormGroup;

    currencySymbol: string;
    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<Dialog1Template>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,
        private _snackBar: MatSnackBar,
        private _fb: FormBuilder,
        private _authService: AuthenticationService

    ) {
        if(data){
            this.header = data;
        }
    }

    ngOnInit() {
        this.form = this._fb.group({
            amount: ['', Validators.required]
        });
        this.currencySymbol = this._authService.userInfo.account.settings.currencySymbol;
    }

    makePayment() {
        const value = this.form.controls['amount'].value;
        if (this.form.valid || value != 0) {
            this.dialogRef.close(value);
        } else{
            this._snackBar.open('Please enter a valid amount', 'Dismiss', {
                duration: 3500
            });
        }
    }
}
